import { Component, Input, Output, OnInit, OnChanges, EventEmitter, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ElectionColleges, HeadCount } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-pap-college',
  templateUrl: 'pap-college.component.html',
  styleUrls: ['./pap-college.component.less', '../../../shared/common.less'],
})

export class PapCollegeComponent implements OnInit, OnChanges {
  @Input() colleges: ElectionColleges[] = [];
  @Input() headcount: HeadCount;
  @Input() partial: boolean = false;
  @Output() collegesChange = new EventEmitter<ElectionColleges[]>();

  lineupErrorMessage: string = '';
  //lineupError: boolean = false;
  remainingEmployee: number = 0;
  limitByCollege: number[] = [];
  needPap: boolean = undefined;
  minDate: string;

  constructor(
    private router: Router,
  ) {
    const today = new Date();
    this.minDate = today.toISOString().substring(0, 10);
  }

  checkLineupLimits() {
    const totalLineup = this.colleges.reduce((sum, college) => sum + (college.lineup || 0), 0);
    if (totalLineup > this.headcount.total) {
      this.lineupErrorMessage = `Vous avez défini dans vos différents collèges un effectif de ${totalLineup} pour un effectif de ${this.headcount.total} votants.`;
    } else {
      this.lineupErrorMessage = '';
    }
  }

  checkFullMembersLimit() {
    const totalFullMembers = this.colleges.reduce((sum, college) => sum + (college.seats || 0), 0);
    if (totalFullMembers != this.headcount.fullMembers) {
      this.lineupErrorMessage = `Vous avez défini dans vos différents collèges un nombre de sièges de ${totalFullMembers} pour un effectif de ${this.headcount.fullMembers} membres titulaires.`;
    } else {
      this.lineupErrorMessage = '';
    }
  }

  checkForErrors() {
    const totalLineup = this.colleges.reduce((sum, college) => sum + (college.lineup || 0), 0);
    const totalFullMembers = this.colleges.reduce((sum, college) => sum + (college.seats || 0), 0);
    
    let errorType = 'none';
    
    if (totalLineup > this.headcount.total) {
      errorType = 'lineup';
    } else if (totalFullMembers != this.headcount.fullMembers) {
      errorType = 'fullMembers';
    }
    
    switch (errorType) {
      case 'lineup':
        this.lineupErrorMessage = `Vous avez défini dans vos différents collèges un effectif de ${totalLineup} pour un ${this.headcount.total} salariés.`;
        break;
      case 'fullMembers':
        this.lineupErrorMessage = `Vous avez défini dans vos différents collèges ${totalFullMembers} sièges pour ${this.headcount.fullMembers} membres titulaires.`;
        break;
      case 'none':
      default:
        this.lineupErrorMessage = '';
        break;
    }
  }

  calculateRemainingEmployees() {
    this.remainingEmployee = this.headcount.total - this.colleges.reduce((sum, college) => sum + (college.lineup || 0), 0);
  }

  onCollegeChange() {
    this.checkForErrors();
    this.calculateRemainingEmployees();
    this.collegesChange.emit(this.colleges);
  }

  goToPollCreation() {
    this.router.navigate(['/poll-creation']);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.calculateRemainingEmployees();
    if (changes['headcount'] || changes['colleges']) {
      this.checkForErrors();
    }
  }

  ngOnInit(): void {
  }
}
